import type { ReactNode } from 'react';

export const symbol_distance: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-80q-106 0-173-31t-67-79q0-22 15.5-41.5T300-266q11-5 22.5-2t16.5 14q5 11 2 22.5T327-215q-8 6-15 12.5T299-190q17 20 70.5 35T480-140q57 0 110.5-15t70.5-35q-6-6-13-12.5T633-215q-11-5-14-16.5t2-22.5q5-11 16.5-14t22.5 2q29 15 44.5 34.5T720-190q0 48-67 79T480-80Zm1-195q109-81 164-164t55-155q0-112-71-169t-149-57q-77 0-148.5 57T260-594q0 73 55 152t166 167Zm-19 58q-9-3-17-9-123-97-184-188.5T200-594q0-71 25.5-124.5t66-89.5q40.5-36 90-54t98.5-18q49 0 99 18t90 54q40 36 65.5 89.5T760-594q0 88-61 179.5T514-226q-8 6-16.5 9t-17.5 3q-9 0-18-3Zm18-303q33 0 56.5-23.5T560-600q0-33-23.5-56.5T480-680q-33 0-56.5 23.5T400-600q0 33 23.5 56.5T480-520Zm0-80Z"
		/>
	</svg>
);
